import { google } from 'calendar-link';

import getIcs, { getEventLocationString } from '../api/shared/_get-ics.js';

export default () => {
  return {
    exportICS: ({ event, title }) => {
      const ics = getIcs({ event, title });
      const file = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
      const url = URL.createObjectURL(file);

      window.location.href = url;
    },

    getGoogleLink: ({ event, title }) => {
      const link = google({
        title: title || event.general?.title || '',
        start: event.general?.startDate,
        end: event.general?.endDate,
        description: '',
        location: getEventLocationString(event),
        url: '',
      });

      return link;
    },
  };
};
